module.exports = __webpack_public_path__ + "img/thumbnail_AmericanBullfrog_u_normal.80a027ea.png";